import View from "components/layout/view";
import Title from "components/title";
import { useTranslate } from "stores/hooks/translation";

const NotFoundView = () => {
  const translate = useTranslate();
  return (
    <View title="404 Not found" description="" navigation={false}>
      <Title>404 {translate("not_found_title")}</Title>
    </View>
  );
};

export default NotFoundView;
